export const storeExclude = ['StoreGroups', 'LogLevels', 'LogTargets', 'SettingKeys'];

export namespace StoreConstants {
  export enum LogLevels {
    OFF = 0,
    DEBUG = 1,
    INFO = 2,
    EVENT = 3,
    WARN = 4,
    ERROR = 5
  }

  export enum LogTargets {
    ALL = 0,
    CONSOLE = 1,
    FILE = 2,
    DB = 3
  }

  export enum SettingKeys {
    app = 'app',
    signedIn = 'signedIn',
    dbReady = 'dbReady',
    session = 'session',
    device = 'device',
    user = 'user',
    userProfile = 'userProfile',
    language = 'language',
    style = 'style'
  }

  export enum StoreGroups {
    App = 'App',
    Db = 'Db',
    Data = 'Data',
    Device = 'Device',
    User = 'User'
  }

  export enum App {
    SHOW_3_D_HOME = 'SHOW_3_D_HOME',

    MENU_CLICKED$ = 'MENU_CLICKED$',
    SHOW_MENU$ = 'SHOW_MENU$',
    MOUSE_POSITION$ = 'MOUSE_POSITION$',
    MENU_REFRESH$ = 'MENU_REFRESH$',
    MENU_ITEMS$$ = 'MENU_ITEMS$$',

    STATE$ = 'STATE$',
    SETTINGS = 'SETTINGS',
    SUBSCRIBERS = 'SUBSCRIBERS',

    DB_READY = 'DB_READY',
    DEVICE_READY = 'DEVICE_READY',
    CACHE_READY = 'CACHE_READY',
    STORE_READY = 'STORE_READY',

    ACTIVE_DIALOG_ID = 'ACTIVE_DIALOG_ID',

    LANGUAGE = 'LANGUAGE',

    IS_ONLINE = 'IS_ONLINE',

    NO_IMAGE = 'NO_IMAGE',
  }

  export enum Db {
    DB_READY = 'DB_READY',
    DATA_READY = 'DATA_READY',
    FEED = 'FEED',
    SYNC = 'SYNC'
  }

  export enum Data {
    COUNTRIES$ = 'COUNTRIES$',
    USER_POLICY$ = 'USER_POLICY$',
    PRIVACY_POLICY$ = 'PRIVACY_POLICY$',
    TERMS_OF_USE$ = 'TERMS_OF_USE$',
    USER_SETTINGS$ = 'USER_SETTINGS$',
    TEAM$ = 'TEAM$',
    ASSETS$ = 'ASSETS$',
    ASSETS = 'ASSETS',
    ASSET_FEEDS$ = 'ASSET_FEEDS$',
    ASSET_FEEDS = 'ASSET_FEEDS',
    ASSET_AUTHORS$ = 'ASSET_AUTHORS$',
    ASSET_AUTHORS = 'ASSET_AUTHORS'
  }

  export enum Device {
    DATA = 'DATA'
  }

  export enum User {
    USER = 'USER',
    USER$ = 'USER$',
    USER_PHOTO = 'USER_PHOTO',
    USER_PHOTO$ = 'USER_PHOTO$',
    SESSION = 'SESSION',
    SESSION$ = 'SESSION$',

    ACTIVATION_PENDING = 'ACTIVATION_PENDING',
    ACTIVATION_PENDING$ = 'ACTIVATION_PENDING$',
    SIGNED_IN = 'SIGNED_IN',
    SIGNED_IN$ = 'SIGNED_IN$'
  }
}
